import { put, takeLatest, select, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { getReport } from 'selectors/reportSelectors';
import { EditReportAction } from 'actions/reportActions';
import { designerSetReport } from 'actions/designerActions';
import { toUrl } from 'ui/main/header/Navigation';
import { getLoginName } from 'selectors/shellSelectors';
import { createNewReport } from 'logic/reports/createNewReport';
import { setReportType } from 'logic/reports/reportType';

export function* editReportWatcher() {
    yield takeLatest('EDIT_REPORT', editReportSaga);
}

export function* editReportSaga(action: EditReportAction) {
    // Look up the report by ID
    const reportId = action.payload;
    const { copy, values } = action.meta;
    if (reportId !== null) {
        // Look up the report and bail out if it doesn't exist
        let report = yield select(getReport, { reportId });
        if (!report) {
            yield call([ console, 'error' ], `Report ${reportId} does not exist`);
            return;
        }

        // Modify the report to the correct type if the type changed
        const reportType = values ? values.reportType : null;
        if (copy && reportType && report.reportType !== reportType) {
            report = setReportType(report, reportType);
        }

        // Load the report into the Report Designer
        yield put(designerSetReport({ ...report, ...(values || {}) }, { isNew: copy }));

        // Navigate to the Report Designer
        const urlFragments = [ 'reports', `${reportId}` ];
        if (copy) {
            urlFragments.push('copy');
        }
        yield put(push(toUrl(...urlFragments)));
        return;
    }

    // Load a new report into the Report Designer
    const owner = yield select(getLoginName);
    const created = yield call([ Date, 'now' ]);
    const newReport = yield call(createNewReport, owner, created, values!.name, values!.reportType, values!.shared);
    yield put(designerSetReport(newReport, { isNew: true }));
            
    yield put(push(toUrl('reports', 'new')));
}



// WEBPACK FOOTER //
// ./src/sagas/reports/editReportSaga.ts